import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { ListsReducerType } from 'redux/reducers/Lists'

export const selectListsStore = createSelector(
  [(state: ApplicationState): ListsReducerType => state.ListsStore],
  (store) => store
)
